/* eslint-disable max-len */
import React from 'react';

const CBCAIcon = (props) => (
  <svg width='56' height='30' viewBox='0 0 56 30' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M28.4249 8.34468C29.4356 8.34468 30.1748 7.62058 30.1748 6.60984C30.1748 5.59911 29.4356 4.875 28.4249 4.875C27.4091 4.875 26.6699 5.59911 26.6699 6.60984C26.6699 7.62058 27.4091 8.34468 28.4249 8.34468ZM28.4249 7.71109C27.8013 7.71109 27.4041 7.23338 27.4041 6.60984C27.4041 5.98128 27.8013 5.50859 28.4249 5.50859C29.0434 5.50859 29.4406 5.98128 29.4406 6.60984C29.4406 7.23338 29.0434 7.71109 28.4249 7.71109Z'
      fill='#4F5D68'
    />
    <path
      d='M17.137 23.9774V20.7831H16.4522V22.0379H14.9437V20.7831H14.2637V23.9774H14.9437V22.6317H16.4522V23.9774H17.137Z'
      fill='#4F5D68'
    />
    <path
      d='M19.2846 24.0348C20.2472 24.0348 20.9512 23.3452 20.9512 22.3827C20.9512 21.4201 20.2472 20.7305 19.2846 20.7305C18.3173 20.7305 17.6133 21.4201 17.6133 22.3827C17.6133 23.3452 18.3173 24.0348 19.2846 24.0348ZM19.2846 23.4314C18.6908 23.4314 18.3125 22.9765 18.3125 22.3827C18.3125 21.784 18.6908 21.3339 19.2846 21.3339C19.8737 21.3339 20.252 21.784 20.252 22.3827C20.252 22.9765 19.8737 23.4314 19.2846 23.4314Z'
      fill='#4F5D68'
    />
    <path
      d='M39.3627 13.912V10.6406H38.6613V11.9256H37.1164V10.6406H36.4199V13.912H37.1164V12.5338H38.6613V13.912H39.3627Z'
      fill='#4F5D68'
    />
    <path
      d='M29.8021 29.162V25.8906H29.1008V27.1756H27.5558V25.8906H26.8594V29.162H27.5558V27.7838H29.1008V29.162H29.8021Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.3658 0.429688L23.8161 2.93693L28.0841 0.690625L29.0156 2.46046L25.7229 4.19348L26.6202 4.81667L25.4795 6.45941L23.7626 5.26718L20.3624 7.32651V11.5536L23.7999 13.4903L27.2374 11.5536V9.20054H29.2374V11.5619L32.5951 13.5084L34.8691 12.4231L35.7306 14.228L33.5811 15.2539L33.7723 19.1737L37.1886 21.1747L41.8173 18.6102L46.133 21.1746L50.8064 18.6198L55.852 21.4536L54.8727 23.1974L50.7933 20.9063L46.0917 23.4765L41.7824 20.9159L37.1611 23.4764L32.7894 20.9158L29.2374 22.9108V25.263H27.2374V22.9028L23.7927 20.9137L21.7266 22.0727L20.7481 20.3284L22.7999 19.1774V15.2224L18.3624 12.7224V6.19958L21.8179 4.10675L19.3589 2.7214L14.8657 5.21765L10.2966 2.71404L5.66135 5.21958L0.803711 2.44379L1.79599 0.7073L5.68835 2.9315L10.3031 0.437043L14.859 2.93344L19.3658 0.429688ZM24.7999 15.2224V19.1857L28.2442 21.1748L31.7709 19.194L31.5776 15.2303L28.2303 13.2898L24.7999 15.2224Z'
      fill='#64737F'
    />
  </svg>
);
export default CBCAIcon;
